const PATH = Object.freeze({
  // ROTAS PÚBLICAS
  LANDING: '/',
  LOGIN: '/login',
  SIGNUP: '/cadastro',
  ASSECIVIL: '/assecivil',
  MAINTENANCE: '/manutencao',
  EULA: '/termos',
  PRIVACY: '/privacidade',

  // ROTAS PRIVADAS
  HOME: '/home',
  USER_DATA: '/dados',
  CALCULATION: '/calculo',
  PAYMENT: '/pagamento',
  DOCUMENTS: '/documentos',
  DOWNLOAD: '/download',
  RESULTS: '/resultado/:fgts',
  ATERMACAO: '/atermacao',
});

export default PATH;
